module.exports = __webpack_public_path__ + "static/media/IMG_4405.97eed2e5.jpg";